import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyboardComponent } from './keyboard.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    KeyboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports:[KeyboardComponent]
})
export class KeyboardModule { }
